<div class="cnt-video" *ngIf="showLoading">
  <div class="video text-center" id="video" >
    <div class="spinner-border" role="status" style="width: 10em; height: 10em;">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>
